'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../../constants/colors';
export const defaultColumnSeriesOptions = fromJS({
  dataLabels: {
    crop: false,
    overflow: 'none',
    style: {
      color: colors.TEXT_COLOR
    }
  },
  borderColor: 'transparent',
  borderWidth: 0
});